var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 11,
  viewBox: "0 0 11 11",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-6-6h24v24H-6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4585FF",
  d: "M5.95 4.37L9.4.92l1.4 1.4-3.45 3.45 3.68 3.68-1.58 1.58-3.68-3.68-3.45 3.45-1.4-1.4 3.45-3.45-3.4-3.4L2.55.97z"
}))));
export default SvgIconClose;